import React from 'react'
import { Icon } from 'loyal-react'

import '@loyal_template/cart.css'

const GuestCart = () => (
  <div className='cart col-md-1 col-auto order-md-4 order-3 d-none d-sm-block'>
    <div className='row align-items-center h-100 justify-content-end justify-content-md-center'>
      <div className='col-auto pos-relative opacity'>
        <Icon
          iconName='icon_cart'
          className='icon_only color-brand-5'
        />
      </div>
    </div>
  </div>
)

export default GuestCart



// WEBPACK FOOTER //
// ./src/App/Header/GuestHeader/GuestCart.js